import React from 'react';
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
// Page links  
export default function AgencyInfo() {
  return (
            <div >
           <Header /> 
         <div className='app_header_height'></div>
    <div className="container_roots">
  
      <Helmet>
        <title>EditorTask - Your Creative & Freelance Agency</title>
        <meta name="description" content="EditorTask connects businesses with top-tier creative talent for freelance opportunities. Whether you need editing, design, or video production, we’ve got you covered." />
        <meta name="keywords" content="freelance agency, creative talent, editors, designers, video production, job portal, freelance marketplace, India jobs, hire editors, freelance opportunities" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        
        <meta property="og:title" content="EditorTask - Your Trusted Creative Freelance Agency" />
        <meta property="og:description" content="EditorTask helps businesses find freelance editors, designers, and creative talent. Post jobs or showcase your creative work today." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>

      <div className="container_size">
        <h1 className="contact-title">Welcome to EditorTask</h1>
        <p className="agency-info-description">
          At EditorTask, we provide businesses with a platform to find top-tier freelance talent in editing, design, video production, and other creative fields. Whether you're an employer looking to post job tasks or a freelancer showcasing your work, EditorTask bridges the gap by connecting you with the right people for the job.
        </p>

        <h2 className="agency-services-title">Our Services</h2>
        <ul className="agency-services-list">
          <li>Freelance Editing Services</li>
          <li>Graphic and Web Design</li>
          <li>Video Production & Editing</li>
          <li>Task Marketplace for Employers</li>
          <li>Creative Portfolio Showcase</li>
        </ul>

        <h2 className="agency-contact-title">Get in Touch</h2>
        <p className="agency-contact-info">
          Interested in joining our platform or posting a job? <br />
          <a href="mailto:contact@editortask.com">Contact us</a> or <a href="/signup">sign up</a> today!
        </p>
      </div>
      </div>
    </div>
  );
}
